export const POST_ADD_DE_TIP_IMG = "portal/m/cw_de_tip_lottie/post_add_de_tip_image.png";
export const FESTIVE_POST_ADD_DE_TIP_IMG = "portal/static-assets/hcms/DE-Tipping-republic.png";
